export default function (features, sizeConversion, isOneSize, sizeMeasurement, hasMeaningfulSize) {
    if (isOneSize && !hasMeaningfulSize) {
        return null;
    }
    return features?.showSizeChart?.(isOneSize, hasMeaningfulSize);
}
